import React from 'react'
import cx from 'classnames'
import * as styles from '../styles/components/banner-image.module.scss'
import DynamicImage, { DynamicImageProps } from './dynamic-image'
import ColorFill, { FillColor } from './color-fill'

interface BannerImageBaseProps {
    imageMode?: 'single' | 'double'
    heightMode?: 'full' | 'half'
    wrapDoubleOnMobile?: boolean
    imageSrc?: string
    colorFill?: FillColor
    className?: string
    altText?: string
    includeNavbarHeight?: boolean
    imageLoadingMode?: DynamicImageProps['imageLoadingMode']
    pixelate?: boolean
}

interface BannerSingleImageProps extends BannerImageBaseProps {
    imageMode: 'single'
}

interface DoubleBannerImageProps extends BannerImageBaseProps {
    imageMode: 'double'
    imageSrcSecondary?: string
    colorFillSecondary?: FillColor
}

export type BannerImageProps = BannerSingleImageProps | DoubleBannerImageProps

const BannerImage = (props: BannerImageProps) => {
    const {
        imageMode, className, wrapDoubleOnMobile = false, imageSrc, colorFill,
        includeNavbarHeight = false, altText, heightMode = 'full',
        imageLoadingMode, pixelate,
    } = props

    const isFullHeight = heightMode === 'full'
    const imageClasses = cx(styles.image, {
        [styles.omitNavbarHeight]: !includeNavbarHeight,
        [styles.halfHeight]: !isFullHeight,
    })

    return (
        <div className={cx(styles.container, className, { [styles.wrap]: wrapDoubleOnMobile })}>
            <div className={cx(styles.imageContainer, {
                [styles.imageLeft]: imageMode === 'double',
                [styles.omitNavbarHeight]: !includeNavbarHeight,
                [styles.halfHeight]: !isFullHeight,
            })}>
                {!imageSrc && colorFill &&
                    <ColorFill className={styles.colorFill} color={colorFill} />
                }
                {imageSrc &&
                    <DynamicImage
                        imageSrc={imageSrc}
                        altText={altText}
                        className={imageClasses}
                        imageLoadingMode={imageLoadingMode}
                        pixelate={pixelate}
                    />
                }
            </div>
            {imageMode === 'double' &&
                <div
                    className={cx(styles.imageContainer, styles.imageRight, {
                        [styles.wrapped]: wrapDoubleOnMobile,
                    })}
                >
                    {props.imageSrcSecondary &&
                        <DynamicImage
                            imageSrc={props.imageSrcSecondary}
                            className={imageClasses}
                            imageLoadingMode={imageLoadingMode}
                            pixelate={pixelate}
                        />
                    }
                    {!props.imageSrcSecondary && props.colorFillSecondary &&
                        <ColorFill className={styles.colorFill} color={props.colorFillSecondary} />
                    }
                </div>
            }
        </div>
    )
}

export default BannerImage

